/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Audio_Player_DemoInputs */

const en_mobile_audio_player_demo = /** @type {(inputs: Mobile_Audio_Player_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio player demo`)
};

const es_mobile_audio_player_demo = /** @type {(inputs: Mobile_Audio_Player_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo del reproductor de audio`)
};

/**
* | output |
* | --- |
* | "Audio player demo" |
*
* @param {Mobile_Audio_Player_DemoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_audio_player_demo = /** @type {((inputs?: Mobile_Audio_Player_DemoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Audio_Player_DemoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_audio_player_demo(inputs)
	return en_mobile_audio_player_demo(inputs)
});